module.exports = __webpack_public_path__ + "img/digitalIdentity10.9b3b4b8f.png";